import {useState, useRef, useEffect} from "react";
import Form, {
    ButtonItem,
    GroupItem,
    RequiredRule,
    SimpleItem,
    AsyncRule,
    PatternRule,
    EmailRule,
} from "devextreme-react/form";
import {useSnackbar} from "notistack";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {FormContainer, Layout} from "../../../../palette/Palette";
import {buttonSuccess} from "../../../../utils/ComponentsSetting";
import {Button} from "devextreme-react/button";
import VerticalSpace from "../../../../palette/VerticalSpace";
import HeaderPage from "../../../../palette/HeaderPage";
import {db} from "../../../../firebase/Firebase";
import Alerts from "../../../../palette/Alerts";
import {cities, namesControl} from "../../../../utils/Utils";
import {FilterDelete, Filters} from "../../../../utils/HelpFunctions";

const state = [{ID: 1, state: 'Activo'}, {ID: 2, state: 'Inactivo'}];

function PassengersManagementFormEdit(props) {

    const {DataStore, setVisibleGrid, setEdit, dataSource, setTrigger, trigger, dataArray} = props

    const {companyName, idCompany,} = DataStore


    const [submitButton, setSubmitButton] = useState({
        ...buttonSuccess,
        text: 'Actualizar pasajeros',
        icon: 'far fa-edit'
    })
    const [load, setLoad] = useState(true)
    const [space, setSpace] = useState(false);
    const [success, setSuccess] = useState(false)
    const [dataSync, setDataSync] = useState(null)

    const {enqueueSnackbar} = useSnackbar();
    const dxForm = useRef(null);

    useEffect(() => {
        const resultArray = FilterDelete(dataArray, 'idUser', dataSource.idUser);
        setDataSync(resultArray);
    }, [dataArray, dataSource])

    const onValueChanged = () => {
        const str = dataSource.email;
        if (str.indexOf(' ') >= 0) {
            setSpace(true)
        } else {
            setSpace(false)
        }
    }

    const renderCancelButton = () => {
        return (
            <Layout row positionL>
                <Button id="cancel-button"
                        icon="fas fa-ban"
                        text="Cancelar"
                        onClick={() => {
                            setEdit(false)
                            setVisibleGrid(true)
                        }}/>
            </Layout>
        )
    }

    const spaceRender = () => {
        return (
            <div>
                {space &&
                <span style={{fontSize: 12, color: 'red'}}>El correo electrónico contiene espacios en blanco</span>}
            </div>
        );
    };

    const renderSuccess = () => {
        return (<Alerts severity="success" body={'Datos actualizados exitosamente!'}/>
        )
    }

    function sendRequest(value) {
        const resultArray = Filters(dataSync, 'idUser', value);
        if (resultArray.length > 0) {
            return new Promise((resolve) => {
                setTimeout(function () {
                    resolve(false);
                }, 500);
            });
        } else {
            return new Promise((resolve) => {
                setTimeout(function () {
                    resolve(true);
                }, 500);
            });
        }
    }

    function asyncValidation(params) {
        return sendRequest(params.value);
    }

    function sendRequestPhone(value) {
        const resultArray = Filters(dataSync, 'contactNumber', value);
        if (resultArray.length > 0) {
            return new Promise((resolve) => {
                setTimeout(function () {
                    resolve(false);
                }, 500);
            });
        } else {
            return new Promise((resolve) => {
                setTimeout(function () {
                    resolve(true);
                }, 500);
            });
        }
    }

    function asyncValidationPhone(params) {
        return sendRequestPhone(params.value);
    }

    function sendRequestEmail(value) {
        const resultArray = Filters(dataSync, 'email', value);
        if (resultArray.length > 0) {
            return new Promise((resolve) => {
                setTimeout(function () {
                    resolve(false);
                }, 500);
            });
        } else {
            return new Promise((resolve) => {
                setTimeout(function () {
                    resolve(true);
                }, 500);
            });
        }
    }

    const asyncValidationEmail = (params) => {
        return sendRequestEmail(params.value);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const docId = dataSource.docId;

        setSubmitButton({...submitButton, disabled: true, text: 'Actualizando...'})

        setLoad(false)

        const newDataPassengers = {...dataSource}
        delete newDataPassengers.docId

        await db.collection(companyName).doc(idCompany).collection('PassengersManagement').doc(docId)
            .set(newDataPassengers).then(() => {
                setSuccess(true)
                setTrigger(!trigger)
                setTimeout(() => {
                    setEdit(false)
                    setVisibleGrid(true)
                    setLoad(true)
                    setSuccess(false)
                    setSubmitButton({...submitButton, disabled: false})
                }, 2000)
            }).catch(() => {
                setLoad(true)
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
            })
    }

    return (
        <>
            <VerticalSpace space={30}/>
            <div className="passengers-management-form">
                <HeaderPage icon={'fas fa-user-tie'} text={'Editar pasajeros'} load={load}
                            textLoad={'Actualizando....'}/>
                <FormContainer>
                    <form action="" onSubmit={handleSubmit}>
                        <Form
                            ref={dxForm}
                            formData={dataSource}
                            readOnly={false}
                            showColonAfterLabel={true}
                            showValidationSummary={true}
                            validationGroup="form-drivers"
                        >
                            <GroupItem caption="Datos" colCount={2}>
                                <SimpleItem dataField="name" label={{text: 'Nombres'}} editorOptions={{maxLength: 25}}>
                                    <RequiredRule message="Ingrese el nombre"/>
                                    <PatternRule message="Solo se permiten letras." pattern={namesControl}/>
                                </SimpleItem>
                                <SimpleItem dataField="lastName" label={{text: 'Apellidos'}}
                                            editorOptions={{maxLength: 25}}>
                                    <RequiredRule message="Ingrese el apellido"/>
                                    <PatternRule message="Solo se permiten letras." pattern={namesControl}/>
                                </SimpleItem>

                                <SimpleItem dataField="idUser" label={{text: 'Cédula/Pasaporte'}}
                                            editorOptions={{maxLength: 20}}>
                                    <RequiredRule message="Ingrese su identificador"/>
                                    <AsyncRule
                                        message="Conductor ya registrado"
                                        validationCallback={asyncValidation}/>
                                </SimpleItem>

                                <SimpleItem dataField="email" label={{text: 'Correo electrónico'}}
                                            editorOptions={{onValueChanged: onValueChanged, maxLength: 70}}>
                                    <EmailRule message="Correo electrónico invalido"/>
                                    <RequiredRule message="Ingrese el correo electrónico del pasajero"/>
                                    <AsyncRule
                                        message={'Este correo electrónico ya a sido registrado'}
                                        validationCallback={asyncValidationEmail}/>
                                </SimpleItem>

                                <SimpleItem dataField="contactNumber" label={{text: 'Núm. de contacto'}}
                                            editorOptions={{maxLength: 20}}>
                                    <RequiredRule message="Ingrese el numero de contacto"/>
                                    <PatternRule message="Ingresar solo números" pattern={/^[0-9+]+$/}/>
                                    <AsyncRule
                                        message="Este número de telefono ya ha sido registrado"
                                        validationCallback={asyncValidationPhone}/>
                                </SimpleItem>

                                <SimpleItem dataField="city" label={{text: 'Ciudad'}} editorType="dxSelectBox"
                                            editorOptions={{
                                                items: cities,
                                                searchEnabled: true,
                                                placeholder: 'Seleccionar...',
                                            }}>
                                </SimpleItem>
                                <SimpleItem dataField="birthdate" label={{text: 'Fecha de nacimiento'}}
                                            editorType="dxDateBox">
                                </SimpleItem>
                                <SimpleItem dataField="state" label={{text: 'Estado'}} editorType="dxSelectBox"
                                            editorOptions={{
                                                dataSource: state,
                                                displayExpr: "state",
                                                valueExpr: "state",
                                                searchEnabled: true,
                                                placeholder: 'Seleccionar...'
                                            }}>
                                    <RequiredRule message="Seleccione el estado"/>
                                </SimpleItem>
                            </GroupItem>
                            <GroupItem colCount={1}>
                                <SimpleItem render={spaceRender}/>
                                {success && <SimpleItem render={renderSuccess}/>}
                            </GroupItem>
                            <GroupItem colCount={2}>
                                <SimpleItem render={renderCancelButton}/>
                                <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>
                            </GroupItem>
                        </Form>
                    </form>
                </FormContainer>
            </div>
        </>
    )

}

export default PassengersManagementFormEdit